export const isElementBottomInView = (element?: HTMLElement | null) => {
  if (!element) {
    return false
  }
  const rect = element.getBoundingClientRect()
  return rect.bottom > 0 && rect.bottom <= window.innerHeight
}
